/**
 * These are the field values which are sent over to the API when
 * exporting constituents via CSV.
 */
enum ConstituentExportFieldName {
  ASSIGNEES = 'assignees',
  BIO = 'biography',
  CATEGORIES = 'categories',
  CUSTOM_FIELDS = 'custom_fields',
  DOB = 'dob',
  EXT_CONSTITUENT_ID = 'ext_constituent_id',
  FIRST_NAME = 'first_name',
  GIVING_SUMMARY = 'giving_summary',
  IS_DECEASED = 'is_deceased',
  LABELS = 'labels',
  LAST_NAME = 'last_name',
  ORG_NAME = 'org_name',
  // TODO: update with actual api value
  PREFERRED_HOUSEHOLD_GREETING = 'preferred_household_greeting',
  PREFIX = 'prefix',
  PRIMARY_ADDRESS = 'primary_address',
  PRIMARY_EMAIL = 'primary_email',
  PRIMARY_PHONE = 'primary_phone',
  // TODO: update with actual api value
  SPOUSE_PARTNER_NAME = 'spouse_partner_name',
  // TODO: update with actual api value
  SPOUSE_PARTNER_EMAIL = 'spouse_partner_email',
}

export default ConstituentExportFieldName;
